import React, { useRef } from "react";

import { FaSearch } from "react-icons/fa";
import { InputGroup, FormControl, FormGroup } from "react-bootstrap";

import './SearchBar.css';

const SearchBar = () => {
  const refForm = useRef({});
  return (
    <div className="navbar-right searchBar">
      <form ref={refForm} className="form-sidebar" action="/#/search" method="get">
        <FormGroup controlId="search">
          <InputGroup>
            <FormControl type="text" data-gtm-search="input" name="s" placeholder="Pesquisar" />
            <InputGroup.Addon><FaSearch onClick={()=> refForm.current.submit()} color="#777777" /></InputGroup.Addon>
          </InputGroup>
        </FormGroup>
      </form>
    </div>
  )
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBar.jsx